import { Box, Typography, styled } from "@mui/material";
import { APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const styles = {
  contributorNavLink: {
    marginRight: "10px",
    marginLeft: "10px",
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    color: APP_COLOR,
  } as const,
  contributorsPhotos: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginTop: "-5px",
    marginBottom: "5px",
    backgroundColor: APP_HOVER_COLOR,
  } as const,
  iconButtonsContainer: {
    display: "flex",
    justifyContent: "right",
    marginTop: "-10px",
  } as const,
  downloadIconButton: {
    paddingTop: "11px",
    color: TEXT_COLOR,
  } as const,
  messageIconButton: {
    color: TEXT_COLOR,
    marginTop: "5px"
  } as const,
  deleteIconButton: {
    color: TEXT_COLOR,
    marginTop: "5px"
  } as const,
  iconColor: {
    color: TEXT_COLOR
  } as const,
  typographyContainer: {
    fontFamily: FONT_FAMILY,
    fontSize: 18,
    fontWeight: "bold",
    borderBottom: "0.5px solid #9FA4A9",
    marginBottom: "5px",
  } as const,
  trackFilesBox: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  } as const,
  linearProgressContainer: {
    width: "100%",
    color: APP_COLOR,
    height: "20vh",
    paddingTop: 10,
  } as const,
  linearProgressMainContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 10px 5px 10px",
    fontFamily: FONT_FAMILY,
    margin: "40px 0",
  },
};

export const VersionDetailsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "left",
  width: "auto",
  padding: "5px 2px 5px 2px",
  borderBottom: "1px solid #9FA4A9",
  margin: "5px 2px 5px 2px",
  [theme.breakpoints.down("md")]: {
    fontSize: 13,
  },
}));

export const LabelDateBox = styled(Box)(({ theme }) => ({
  display: "flex",
  whiteSpace: "nowrap",
  overflow: "hidden",
  width: "calc(100%)",
  textOverflow: "ellipsis",
  marginLeft: "auto",
  fontSize: 15,
  alignItems: "center",
  justifyContent: "space-around",
  [theme.breakpoints.down("md")]: {
    marginRight: 25,
    marginLeft: 10,
    fontSize: 13,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
}));

export const TimeBox = styled(Box)(({ theme }) => ({
  display: "flex",
  width: 350,
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const NameText = styled(Typography)(({ theme }) => ({
  display: "flex",
  fontFamily: FONT_FAMILY,
  fontWeight: "bold",
  width: 300,
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: 12,
    justifyContent: "flex-start",
  },
}));

export const DateText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  display: "flex",
  marginLeft: 30,
  justifyContent: "center",
  textAlign: "center",
  width: 200,
  [theme.breakpoints.down("md")]: {
    fontSize: 10,
    marginLeft: 0,
    justifyContent: "flex-start",
    textAlign: "inherit",
  },
}));

export const InlineSize = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  display: "none",
  marginLeft: 20,
  textAlign: "center",
  width: 200,
  [theme.breakpoints.down("md")]: {
    display: "flex",
    fontSize: 10,
    marginLeft: 0,
    textAlign: "inherit",
    fontWeight: "bold",
  },
}));

export const LabelText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  margin: "0 10px",
  width: 300,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const TypeText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  width: 115,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
